export default {
  setUser({ commit }, user) {
    commit("setUser", user);
  },
  setUserCredentials({ commit }, cred) {
    commit("setUserCredentials", cred);
  }
};
